//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { Toast } from 'mint-ui'
export default {
  name: 'user-return-page',
  data() {
    return {
      form: {
        bookingId: this.$route.query.id,
        suggestion: '',
        qa_rating: 0,
        exam_rating: 0,
        total_rating: 0,
      },
      popupVisible: false
    }
  },
  computed: mapState({
    user: state => state.user.user
  }),
  mounted: function () {
  },
  methods: {
    getQueryVariable: function (variable) {
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
          var pair = vars[i].split("=");
          if(pair[0] == variable){return pair[1];}
       }
       return(false);
    },
    setQaRating(rating){
      this.form.qa_rating = rating
    },
    setExamRating(rating){
      this.form.exam_rating = rating
    },
    setToatalRating(rating){
      this.form.total_rating = rating
    },
    submit () {
      console.log(this.form)
      const body = Object.assign({}, this.form)
      this.$store.httpDispatch({})('returnBooking', body).then((res) => {
        const { code, data, msg } = res.data
        if (code === 0) {
          Toast({
            message: '提交成功',
            duration: 3000
          })
        } else {
          Toast({
            message: msg,
            duration: 3000
          })
        }
      }).catch((err) => {
        console.log(err)
        const { data } = err
        Toast({
          message: data.msg || '網絡錯誤',
          duration: 3000
        })
      })
    }
  }
}
